import { render, staticRenderFns } from "./ParagraphSpacingIcon.vue?vue&type=template&id=9036700e&"
import script from "./ParagraphSpacingIcon.vue?vue&type=script&lang=js&"
export * from "./ParagraphSpacingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports